var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotlightActiveLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "rgba(24, 29, 36, 1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 29.1111L22 29.1111V22.8889C22 22.6531 22.0936 22.427 22.2603 22.2603C22.427 22.0937 22.6531 22 22.8889 22L37.1111 22C37.3469 22 37.573 22.0937 37.7397 22.2603C37.9063 22.427 38 22.6531 38 22.8889V29.1111ZM29.1111 38H22.8889C22.6531 38 22.427 37.9064 22.2603 37.7397C22.0936 37.573 22 37.3469 22 37.1111L22 30.8889L29.1111 30.8889L29.1111 38ZM38 37.1111C38 37.3469 37.9063 37.573 37.7397 37.7397C37.573 37.9064 37.3469 38 37.1111 38H30.8889L30.8889 30.8889H38V37.1111Z",
    fill: "#DFE5F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlightActiveLight);
export default __webpack_public_path__ + "static/media/spotlightActiveLight.45639db3f7ae5ec6bc280df648347331.svg";
export { ForwardRef as ReactComponent };